'use client';

import { DeploymentDelaySettingsCard } from '@terra/ui-design-system';
import { useApplicationById } from '../../../hooks/api/useApplicationById';
import { useTicketingIntegrationConnected } from '../../../hooks/api/useTicketingIntegrationConnected';
import { useApplicationGeneralFields } from './useApplicationGeneralFields';
import { useTicketingRetestDelayToggle } from './useTicketingRetestDelayToggle';

type TargetDeploymentDelayPanelProps = {
  applicationId: string;
  isReadOnly?: boolean;
};

export function TargetDeploymentDelayPanel({
  applicationId,
  isReadOnly,
}: TargetDeploymentDelayPanelProps) {
  const { application } = useApplicationById({ id: applicationId });
  const { saveFields, isSavingFields } = useApplicationGeneralFields({
    applicationId,
  });
  const { hasTicketingIntegrationConnected } =
    useTicketingIntegrationConnected();
  const currentApplyDelayToTicketingRetests =
    application?.applyDeploymentDelayToTicketingRetests ?? false;
  const {
    isUpdating: isUpdatingTicketingRetestDelay,
    handleCheckedChange: handleTicketingRetestDelayChange,
  } = useTicketingRetestDelayToggle({
    applicationId,
    currentValue: currentApplyDelayToTicketingRetests,
    isReadOnly,
  });

  return (
    <DeploymentDelaySettingsCard
      currentDelayHours={application?.waitingHoursForDeployment}
      isReadOnly={isReadOnly}
      isUpdatingDelay={isSavingFields}
      onSaveDelay={(hours) => saveFields({ waitingHoursForDeployment: hours })}
      ticketingRetest={{
        checked: currentApplyDelayToTicketingRetests,
        isAvailable: hasTicketingIntegrationConnected,
        isUpdating: isUpdatingTicketingRetestDelay,
        onCheckedChange: (checked) =>
          void handleTicketingRetestDelayChange({ checked }),
      }}
    />
  );
}
